module.exports = __webpack_public_path__ + "website/img/successfulDetail_4_9.d80b6fab.jpg";